import {connect} from 'pwa-helpers';
import {LitElement, html} from 'lit';
import {navigator, router} from 'lit-element-router';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {msg} from '@lit/localize';
import {fetchSubscriptions, selectTotalSubscriptions, selectAllSubscriptions} from '../../slices/subscriptionSlice';

import store from '../../store';
import style from '../../../../scss/subscriptionList.scss';
import listStyle from '../../../../scss/list.scss';
import {
	selectLanguage
} from '../../selectors';
import getRoutes from '../../routes';
import down from '../../icons/down';
import up from '../../icons/up';

@customElement('arc-subscription-list')
export class SubscriptionList extends connect(store)(router(navigator(LitElement))) {
	static styles = [listStyle, style];

	static properties = {
		showFilter: {type: Boolean},
	};

	constructor() {
		super();
		this.currentLanguage = 'de';
		this.activities = [];
		this.subscriptions = [];
		this.listType = 'all';
		this.showFilter = true;
		this.query = {};
		store.subscribe(() => this.requestUpdate());
		this.pageSize = 50;
	}

	stateChanged(state) {
		this.state = state;
		this.status = state.status;
		this.lang = selectLanguage(state);
		this.subscriptions = selectAllSubscriptions(state);
		//this.logsQuery = selectLogsQuery(state);
		this.totalPages = Math.ceil(selectTotalSubscriptions(state) / this.pageSize);
		if (this.updateNeeded) {
			this.updateNeeded = false;
			store.dispatch(fetchSubscriptions({...this.query}));
		}
		this.requestUpdate();
	}

	static get routes() {
		return getRoutes();
	}

	router(route, params, query, data) {
		// do activities need update from backend
		// this.updateNeeded = (route === 'admin-activities' || route === 'artwork') &&
		// 	(!deepEqual(this.query, query) || this.artworkId !== params.id);
		this.params = params;
		this.query = query;
		this.data = data;
	}

	connectedCallback() {
		super.connectedCallback();
		if (this.showFilter) {
			store.dispatch(fetchSubscriptions());
		}
	}

	getOrderQuery(orderBy) {
		return {
			...this.query,
			...{
				orderBy: orderBy,
				orderByDirection: this.logsQuery.orderByDirection === 'desc' ? 'asc' : 'desc'
			}
		};
	}

	getOrderDirectionIcon(orderBy) {
		if (this.query.orderBy === orderBy) {
			return this.logsQuery.orderByDirection === 'asc' ? down : up;
		} else {
			return '';
		}
	}

	render() {
		return html`
			<div class="list subscriptionList">
				${this.subscriptions.length > 0
					? html`
						<div class="listHeader">
							<div>${msg('Id')}</div>
							<div>${msg('Account')}</div>
							<div>${msg('Status')}</div>
							<div>${msg('Payment Provider')}</div>
							<div>${msg('Trial End')}</div>
							<div>${msg('Cancelled To')}</div>
						</div>
						${repeat(
							this.subscriptions,
							(s) => s.id,
							(s, index) => html`
								<div>
									<arc-subscription-list-item .subscription=${s}></arc-subscription-list-item>
								</div>`
						)}
						<arc-pagination .totalPages=${this.totalPages}></arc-pagination>
					`
					: html` <p class="emptyMessage">${msg('No subscriptions.')}</p> `}
			</div>
		`;
	}
}
